import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";

import React from "react";
import { SWRConfig } from "swr";
import { SnackbarProvider } from "notistack";
import { BrowserRouter as Router } from "react-router-dom";
// import ReactGA from "react-ga4";
import { createGlobalStyle } from "styled-components";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import PageViewTracker from "./components/PageViewTracker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tr } from "date-fns/locale";
import { AdminProvider } from "./context";

import { MapProvider } from "./context/MapContext";
import { HelmetProvider } from "react-helmet-async";
import WhatsappWidget from "./components/common/WhatsappWidget";
import AppRoutes from "./routes/common/AppRoutes";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Inter', 'Roboto', sans-serif;
  }
  a{
    color: unset;
    text-decoration: none;
  }
`;

const theme = createTheme({
  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
  },
  palette: {
    secondary: { main: "#002B32" },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: "xl",
      },
    },
    MuiTextField: {
      defaultProps: {
        slotProps: {
          inputLabel: {
            shrink: true,
          },
        },
      },
    },
  },
});

// const GA_MEASUREMENT_ID = "G-RHMGJH0EDY"; // Kendi GA4 Ölçüm Kimliğinizi kullanın

const App: React.FC = () => {
  // useEffect(() => {
  //   ReactGA.initialize(GA_MEASUREMENT_ID);
  //   ReactGA.send({
  //     hitType: "pageview",
  //     page: window.location.pathname + window.location.search,
  //   });
  // }, []);

  return (
    <SnackbarProvider>
      <SWRConfig>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
            <CssBaseline />
            <GlobalStyle />
            <AdminProvider>
              <HelmetProvider>
                <MapProvider>
                  <Router>
                    <PageViewTracker />
                    <WhatsappWidget />
                    <AppRoutes />
                  </Router>
                </MapProvider>
              </HelmetProvider>
            </AdminProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </SWRConfig>
    </SnackbarProvider>
  );
};

export default App;
